import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    createPerpayPlusSoloFeatureEnrollment,
    createPerpayPlusSoloFeatureEnrollmentError,
    createPerpayPlusSoloFeatureEnrollmentReset,
    createPerpayPlusSoloFeatureEnrollmentSuccess,
} from '@perpay-web/fintech/actions/entities/perpayPlusSolo';
import { FEATURE_ENROLLMENTS_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { authenticatedJsonFetch } from '@perpay-web/fintech/utils/requestHandlers';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useCreatePerpayPlusSoloFeatureEnrollmentDataModule = () => {
    const dataModule = useDataModule(
        (payload) =>
            authenticatedJsonFetch(
                FEATURE_ENROLLMENTS_ENDPOINT,
                payload,
                HTTPMethod.post,
            ).catch((error) => {
                if (error && error.response) {
                    const modifiedError = {
                        ...error,
                        message:
                            error.response.message || error.response.feature,
                    };
                    throw modifiedError;
                }
                throw error;
            }),
        { timeout: 30000 },
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: createPerpayPlusSoloFeatureEnrollment,
        error: createPerpayPlusSoloFeatureEnrollmentError,
        success: createPerpayPlusSoloFeatureEnrollmentSuccess,
        reset: createPerpayPlusSoloFeatureEnrollmentReset,
    });

    return { ...dataModule };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useCreatePerpayPlusSoloFeatureEnrollmentDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseCreatePerpayPlusSoloFeatureEnrollmentDataModuleProvider,
    useCreatePerpayPlusSoloFeatureEnrollmentContext,
] = createContextProvider(providerFactory);
